module.exports = {
  NOT_STARTED: 'notStarted',
  CURRENT: 'current',
  CLOSED: 'closed',
};
